import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Card, CardContent, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import ListItemText from '@mui/material/ListItemText';
import { AppContext } from '@/AppContext';
import { shortenDate } from '../../../MeetupList/components/MeetupsTable/MeetupsTable';

const PREFIX = 'PaymentsTable';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
  inner: `${PREFIX}-inner`,
  nameContainer: `${PREFIX}-nameContainer`,
  avatar: `${PREFIX}-avatar`,
  actions: `${PREFIX}-actions`,
  fab: `${PREFIX}-fab`,
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`&.${classes.root}`]: {},

  [`& .${classes.content}`]: {
    padding: 0,
  },

  [`& .${classes.inner}`]: {
    minWidth: 600,
  },

  [`& .${classes.nameContainer}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.avatar}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${classes.actions}`]: {
    justifyContent: 'flex-end',
  },

  [`& .${classes.fab}`]: {
    margin: theme.spacing(1),
  },
}));

const PaymentsTable = props => {
  const { className, payments, ...rest } = props;
  const appContext = useContext(AppContext);

  return (
    <StyledCard {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <div className={classes.inner}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Id аккаунта</TableCell>
                <TableCell>Название</TableCell>
                <TableCell>Дата</TableCell>
                <TableCell>Заказ</TableCell>
                <TableCell>Транзакция</TableCell>
                <TableCell>Сумма</TableCell>
                <TableCell>Статус</TableCell>
                <TableCell>Коммент</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {payments.map((payment, i) => (
                <TableRow
                  hover
                  key={i}
                  onClick={() => appContext.history.push('/sa/payment/' + payment.accountId + '/' + payment.orderId)}
                  style={{ cursor: 'pointer' }}
                >
                  <TableCell>
                    <ListItemText primary={payment.accountId} />
                  </TableCell>
                  <TableCell>
                    <ListItemText primary={payment.accountName} />
                  </TableCell>
                  <TableCell>
                    <ListItemText primary={shortenDate(payment.date)} />
                  </TableCell>
                  <TableCell>
                    <ListItemText primary={payment.orderId} />
                  </TableCell>
                  <TableCell>
                    <ListItemText primary={payment.transactionId} />
                  </TableCell>
                  <TableCell>
                    <ListItemText primary={payment.amount} />
                  </TableCell>
                  <TableCell>
                    <ListItemText primary={payment.paymentResult ? 'Успешно' : 'Отклонён'} />
                  </TableCell>
                  <TableCell>
                    <ListItemText primary={payment.comment} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </StyledCard>
  );
};

PaymentsTable.propTypes = {
  className: PropTypes.string,
  accounts: PropTypes.array.isRequired,
};

export default PaymentsTable;
